import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {PageAccessStorageService} from '../../store/page-access-storage.service';
import {PageAccessInfo} from '../../models/page-access-info';
import {Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class PageAccessInfoGuardService implements CanActivate {
  constructor(private router: Router,
              private pageAccessStorageService: PageAccessStorageService) {
  }

  canActivate(): Observable<boolean> {
    if (this.pageAccessStorageService.pageAccessInfo && this.pageAccessStorageService.pageAccessInfo.isAuthorized) {
      return of(true);
    }

    return this.pageAccessStorageService.onTogglePageAccessInfo.pipe(
      map((pageAccessInfo: PageAccessInfo): boolean => {

        if (pageAccessInfo && pageAccessInfo.isAuthorized) {
          return true;
        }

        this.router.navigate(['access_denied']);
        return false;
      })
    );
  }
}
